// Centralized PDF.js configuration - import this ONCE at app startup
import { pdfjs } from "react-pdf";

// Vite-native worker import (no CDN, no CORS issues)
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.min.mjs?url";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// PDF.js options
// Note: Avoid remote cMap/font URLs (can hang or be blocked on iOS / restrictive networks).
// If we later need cMaps for special PDFs, we'll ship them locally.
export const pdfOptions = {};
